import getVersion from '../utils/get-version.js';

const VERSION: string = getVersion();

export default VERSION;
